import { SxProps, Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ShowDetailsModalStyles = styled('div')`
    padding-bottom: 16px;
`;

export const Label = styled('button')(
    ({ theme }) => `
    display: flex;
    align-items: center;
    gap: 6px;
    color: ${theme.palette.primary.main};
    cursor: pointer;
    border: none;
    background-color: ${theme.palette.grey[50]};
    padding: 0;
    font-size: 1rem;
    font-family: 'Inter', sans-serif;
`,
);

export const HeaderStyles = styled('div')`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const IconStyles: SxProps<Theme> = (theme) => ({
    color: theme.palette.grey[900],
});

/**
 * Tightens the spacing of the HTML the dialog is handed, which arrives as headings and paragraphs and would otherwise
 * carry the browser's default margins.
 *
 * These used to live in global.css as `#dialog-content` rules. They are scoped to the component now that the element
 * id is generated per instance -- the id exists for aria-describedby, not for styling. The global rules stay where
 * they are because CountryCodeDialog still uses that id.
 */
export const DialogContentStyles: SxProps<Theme> = {
    '& h4': { marginBottom: 0 },
    '& p': { marginTop: 0 },
    '& p:last-child': { marginBottom: 0 },
};
